import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheckOutline.js'
import IconLock from '@adv-mt/mt-svg-icons/lib/LockOutline.js'
import {BADGE_INTENTS} from '@adv-mt/ui/badge'

export const RESERVATION_PLACEMENTS = {
  ASIDE: 'aside',
  INLINE: 'inline'
}

export const getInfoByReservationStatus = reservationStatus => ({
  [reservationStatus.OTHER_RESERVATION]: {
    badge: {
      Icon: IconLock,
      intent: BADGE_INTENTS.INFO,
      text: 'VEHICLE_RESERVATION.NOTIFICATION.OTHER_RESERVATION.TEXT'
    },
    hasManageButton: false,
    text: null,
    title: 'VEHICLE_RESERVATION.NOTIFICATION.OTHER_RESERVATION.TITLE'
  },
  [reservationStatus.OWN_RESERVATION]: {
    badge: {
      Icon: IconCircleCheck,
      intent: BADGE_INTENTS.SUCCESS,
      text: 'VEHICLE_RESERVATION.NOTIFICATION.OWN_RESERVATION.TEXT'
    },
    hasManageButton: true,
    text: 'VEHICLE_RESERVATION.NOTIFICATION.OWN_RESERVATION.DESCRIPTION',
    title: 'VEHICLE_RESERVATION.NOTIFICATION.OWN_RESERVATION.TITLE'
  }
})
